<template>
  <div>
      <v-progress-linear rounded class="white mb-5" color="amber" height="15" :value="Object.keys($store.state.data.post.answer).length/form.length*100"></v-progress-linear>
        <timer v-if="data_api.use_timer==1"/>
      <div class="form-page">
        
        <transition :name="transitionName" mode="out-in">
          <questions v-if="show" :form="form" :currentPage="currentPage" :totalPage="totalPage" :isTrivia="isTrivia" :percentage="percentage||null" />
        </transition>
        <Answer v-if="data_api.type=='pick_a_pict'" :currentPage="currentPage" :totalPage="totalPage" :form="data_api.pick_a_pict"/>

      </div>
    
  </div>
</template>

<script>
const Questions = () => import(/* webpackChunkName: "questions" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './Questions.vue');
const Timer = () => import(/* webpackChunkName: "timer" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './Timer/Main.vue');
const Answer = () => import(/* webpackChunkName: "quiz" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './PickAPict/Answer.vue');

export default {
  components: { Questions,Timer,Answer },
  name: "Horizontal",
  props:['form', 'isTrivia', 'percentage'],
  data() {
    return {
      totalPage: this.form.length,
      currentPage: 1,
      jumpPage: 0,
      show: false,
      transitionName: 'slide-left',
      data_api: this.$store.state.data.get,
    }
  },

  created()
  {
      this.viewTracker('question-'+this.currentPage);
      this.$parent.$parent.$parent.updateHead();
  },

  watch: {
    currentPage: {
      immediate: true,
      deep: true,
      handler() 
      {
        this.show = false
        var th = this

        setTimeout(function(){
          th.show = true
        },100);
      }
    }
  },

  methods:{
    
    prev()
    {
        if(this.currentPage>1) 
        {
          
          this.currentPage--

          this.viewTracker('question-'+this.currentPage);
          this.$parent.$parent.$parent.updateHead();
        }
    },

    next()
    {
      //Send Tracker
      this.sendtoCDP()
      this.sendExternalTracker()

     //next with logic jump
      if( this.jumpPage )
      {
        if(this.jumpPage=='result')
        {
          //submit
          this.$store.commit('set_isvalid_answer', true);
          this.$parent.$parent.submit();
        }
        else
        {
          this.currentPage = this.jumpPage 
          this.jumpPage = null;
        }
      }
      else
      {
        //next page
        if(this.currentPage<this.totalPage) 
        {
          
          this.currentPage++

          this.viewTracker('question-'+this.currentPage);
          this.$parent.$parent.$parent.updateHead();

        }
        else
        {
          //submit
          this.$parent.$parent.submit();
        }
      }

      //set current page
      this.$store.state.data.post.interactive_page = this.currentPage

      //re validate answer
      if( this.currentPage == this.totalPage )
      {
        //check all answer & form
        if(Object.keys(this.$store.state.data.post.answer).length == this.form.length)
        {
          this.$store.commit('set_isvalid_answer', true);
        }
      }
    }

  }
}
</script>